import * as yup from 'yup'
import { VALID_NAME_PATTERN } from "components/SavedReports/yupSchemas";

export const instantExportSchema = yup.object().shape({
  filename: yup.string()
    .required('File Name is required')
    .matches(
      VALID_NAME_PATTERN,
      'Export file name contains invalid characters. Please try again.'
    ),
})
